export class SocketWrapperMessage {
}
